import { FC, SVGAttributes } from 'react';

const CheckEmpty: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6666 14.25C25.6666 20.6934 20.4432 25.9167 13.9999 25.9167C7.5566 25.9167 2.33325 20.6934 2.33325 14.25C2.33325 7.80672 7.5566 2.58337 13.9999 2.58337C20.4432 2.58337 25.6666 7.80672 25.6666 14.25ZM13.9999 24.1667C19.4767 24.1667 23.9166 19.7269 23.9166 14.25C23.9166 8.77322 19.4767 4.33337 13.9999 4.33337C8.5231 4.33337 4.08325 8.77322 4.08325 14.25C4.08325 19.7269 8.5231 24.1667 13.9999 24.1667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckEmpty;
